import {BomSubstitution} from "./bom-substitution";

export interface BomComponentAnalysisRow {
    bom_component_id: number | null;
    bom_number: string;
    level: number;
    item: number | null;
    part_number: string;
    description?: string | null;
    mtype: string;
    can_substitute: boolean;
    quantity: number | string;
    unit?: string;
    purchase_priority?: number;
    purchase_priority_label?: string;
    consumption_priority?: number;
    is_phantom: boolean;
    is_imperfect?: boolean;
    substitution: BomSubstitution | null;
    // Manual-addition overlay markers (present on rows added to the BOM within the simulation).
    is_manual_addition?: boolean;
    addition_id?: number | null;
    anchor_component_id?: number | null;
    parent_addition_id?: number | null;
    relation?: number | null;
    position?: number | string | null;
    active?: boolean;
    start_date?: string | null;
    end_date?: string | null;
}

// Mirrors core.models.BomComponentAddition.Relation (backend IntegerChoices).
export enum BomAdditionRelation {
    ABOVE = 1,
    BELOW = 2,
    CHILD = 3,
}
